// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Interesting_wrapper__3A1j7","title":"Interesting_title__2xJQi","wrap":"Interesting_wrap__dNaQf","card":"Interesting_card__39dPd","btns":"Interesting_btns__7ZuTY"};